import Api from "../../helpers/apiHandler";

const api = new Api();
const PREFIX = "superAdmin/usda-ingredient/";

const jsonBody = (data) => ({
  isMultipart: false,
  data: data || {},
});

export function isApiOk(res) {
  return Boolean(res && Number(res.status) === 1);
}

export function apiMessage(res, fallback) {
  if (res && (res.message || res.msg)) {
    return res.message || res.msg;
  }
  return fallback;
}

export function apiPayload(res) {
  if (res && res.data !== undefined) {
    return res.data;
  }
  return res || {};
}

export const CONFLICT_MESSAGE = "This ingredient was changed by someone else. Reload it and try again.";

/** Backend message keys that may come back untranslated. */
const ERROR_TEXT = {
  usda_master_conflict: CONFLICT_MESSAGE,
  usda_master_lists_required:
    "Nutrition, allergens and volume measurements must all be sent. Reload the page and try again.",
  usda_master_allergen_engine_failed:
    "Allergens could not be detected automatically. Select the allergens (or No allergens) and save again.",
  usda_master_invalid_status: "The status could not be changed. Reload the page and try again.",
};

/** HTTP 409 from save / set-active: someone else saved a newer version. */
export function isConflict(res) {
  if (!res) {
    return false;
  }
  const msg = String(res.message || res.msg || "");
  return (
    msg === "usda_master_conflict" ||
    msg === CONFLICT_MESSAGE ||
    /changed by (someone|another)/i.test(msg) ||
    Number(res.httpStatus) === 409 ||
    Number(res.statusCode) === 409 ||
    Number(res.code) === 409
  );
}

/** apiMessage, with known message keys turned into readable text. */
export function apiErrorMessage(res, fallback) {
  const msg = apiMessage(res, fallback);
  return ERROR_TEXT[msg] || msg;
}

const withVersion = (body, expectedVersion) =>
  expectedVersion === null || expectedVersion === undefined ? body : { ...body, expectedVersion };

export const usdaIngredientApi = {
  lookups: () => api.get(`${PREFIX}lookups`),
  list: (payload) => api.post(`${PREFIX}list`, jsonBody(payload)),
  view: (fdcId) => api.post(`${PREFIX}view`, jsonBody({ fdcId })),
  save: (payload) => api.post(`${PREFIX}save`, jsonBody(payload)),
  // setActive: (fdcId, active) => api.post(`${PREFIX}set-active`, jsonBody({ fdcId, active })),
  setActive: (fdcId, active, expectedVersion) =>
    api.post(`${PREFIX}set-active`, jsonBody(withVersion({ fdcId, active }, expectedVersion))),
  revert: (fdcId) => api.post(`${PREFIX}revert`, jsonBody({ fdcId })),
  auditLog: (payload) => api.post(`${PREFIX}audit-log`, jsonBody(payload)),
};

/** Instants arrive as ISO strings; epoch seconds or milliseconds are tolerated too. */
export function formatDisplayDate(value) {
  if (value === null || value === undefined || value === "") {
    return "--";
  }
  let input = value;
  if (typeof value === "number" && value < 100000000000) {
    input = value * 1000;
  }
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) {
    return String(value);
  }
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}, ${hours}:${minutes}`;
}
